var metadata = require('core/metadata');

module.exports = {
	READWORKS_COLLECTION_NODE_ID: 414,
	gradesToStrings: function (grades) {
		var texts = [];
		grades.forEach(g => {
			var grade = metadata.gradesById['_' + g];
			if (grade) {
				texts.push(grade.text);
			}
		});
		return texts;
	},

	// Credit to https://stackoverflow.com/questions/12487422/
	getOrdinal: function (n) {
		// is it numeric
		if (!isNaN(n)) {
			n = parseInt(n);
		} else {
			return n;
		}

		if (parseFloat(n) == parseInt(n)) {
			var s = ['th', 'st', 'nd', 'rd'],
				v = n % 100;
			return n + (s[(v - 20) % 10] || s[v] || s[0]);
		}
		return n;
	},

	domainsToString: function (domainIdsArray, metaData) {
		if (!domainIdsArray || !domainIdsArray.length) {
			return '';
		}

		var myDomains = {},
			domainString = '';

		domainIdsArray.forEach(function (d) {
			myDomains[d] = true;
		});

		metaData.domainNode.children.forEach(function (d) {
			// assuming metaData's domains are in the correct order, and h2.domains isn't necessarily...
			if (myDomains[d.id]) {
				var topicDomain = metaData.domainsById['_' + d.id],
					childString = '';

				topicDomain.children.forEach(function (c, i) {
					if (myDomains[c.id]) {
						childString += ', ' + c.name;
					}
				});

				if (childString) {
					domainString += ', ';
					domainString += childString.substring(1, childString.length);
				}
			}
		});

		if (metaData.socialEmotionalNode) {
			metaData.socialEmotional.forEach(sel => {
				if (myDomains[sel.id]) {
					domainString += ', ';

					var selNode = metaData.allActiveNodesById['_' + sel.id];

					domainString += selNode.name;
				}
			});
		}

		return domainString.substring(1, domainString.length);
	},

	libraryTopicsToString: function (topics, metaData) {
		if (!topics || !topics.length) {
			return '';
		}

		let topicMap = {};

		if (metaData.genres) {
			topicMap = metaData.genres.reduce((acc, g) => {
				acc[g.rms_key] = g;
				return acc;
			}, {});
		}

		if (metaData.skf) {
			topicMap = metaData.skf.reduce((acc, s) => {
				acc[s.rms_key] = s;
				return acc;
			}, topicMap);
		}

		let topicList = topics.reduce((acc, t) => {
			let node = topicMap[t];
			if (node) {
				acc.push(node.name);
			}
			return acc;
		}, []);

		return topicList.join(', ');
	},

	getPartner: function (cid) {
		if (!cid) {
			return null;
		}

		var partners = metadata.partnersNode.children;

		for (var i = 0, l = partners.length; i < l; i++) {
			var sc = partners[i];

			if (sc.id === cid) {
				return sc;
			}
		}

		return null;
	}
};
